module.exports = __webpack_public_path__ + "img/img7.2d33d83b.svg";